import './Header.scss'
import { LogoWhite } from "../../ui/Logo/LogoWhite";
import { Navigation } from "../Navigation/Navigation";
import { useEffect, useRef, useState } from 'react';
import { Search } from '../../ui/Search/Search';
import { userApi } from '../../redux/services/userApi';
import { useLocation } from 'react-router-dom';
import { FormModal } from '../FormModal/FormModal';
import { useWindowResize } from '../hooks/useWindowResize';
import { ProfileLink } from '../ProfileLink/ProfileLink';
import { SearchIcon } from '../../ui/Icon/SearchIcon';

export interface FormModalProps {
  logRegModal: boolean;
  setLogRegModal: (value: boolean) => void;
  successModal: boolean;
  setSuccessModal: (value: boolean) => void;
}

export const Header = () => {

  const urlPathname = useLocation().pathname

  const { data: userProfile } = userApi.useUserProfileQuery(`/profile`)

  const [logRegModal, setLogRegModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [searchVisible, setSearchVisible] = useState(false);

  const resize = useWindowResize()

  const searchRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (searchVisible && searchRef.current && !searchRef.current.contains(event.target as Node)) {
        setSearchVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [searchVisible]);

  return (
    <>
      <div className={`overlay ${searchVisible ? 'overlay--active' : ''}`}></div>
      <header className="header">
        <div className="container">
          <div className='header__container'>
            <LogoWhite />
            <Navigation urlPathname={urlPathname} />
            {resize ? (
              <button className="nav__link" onClick={() => setSearchVisible(true)}>
                <SearchIcon />
              </button>
            ) : (
              <Search setSearchVisible={setSearchVisible} />
            )}
            {searchVisible && (
              <div className='header__search' ref={searchRef}>
                <Search setSearchVisible={setSearchVisible} />
              </div>
            )}
            <ProfileLink
              userProfile={userProfile}
              urlPathname={urlPathname}
              resize={resize}
              logRegModal={logRegModal}
              setLogRegModal={setLogRegModal}
            />
            <FormModal logRegModal={logRegModal} setLogRegModal={setLogRegModal} successModal={successModal} setSuccessModal={setSuccessModal} />
          </div>
        </div>
      </header>
    </>
  )
}